var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      on: {
        close: function($event) {
          _vm.$emit("toggleShowMessagesModal")
        }
      }
    },
    [
      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
        _c("h4", [_vm._v("Send SMS to movers")])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          class: "l-modal-body container",
          attrs: { slot: "body" },
          slot: "body"
        },
        [
          _c("div", { staticClass: "row mb-2" }, [
            _c("div", { staticClass: "col-12 px-0" }, [
              _c(
                "div",
                { staticClass: "select-wrap" },
                [
                  _c("label", [_vm._v("SEND TO:")]),
                  _vm._v(" "),
                  _vm.assignedMovers
                    ? _c("simple-select", {
                        attrs: {
                          options: _vm.assignedMovers,
                          label: "full_name",
                          placeholder: "Select Movers"
                        },
                        on: { input: _vm.getThread },
                        model: {
                          value: _vm.selectedMover,
                          callback: function($$v) {
                            _vm.selectedMover = $$v
                          },
                          expression: "selectedMover"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row mb-4 scrollable" },
            [
              _vm.loadingMessages
                ? [
                    _c(
                      "div",
                      { staticClass: "col-12 px-0" },
                      [
                        _c(
                          "vue-content-loading",
                          { attrs: { width: 800, height: 250 } },
                          _vm._l(3, function(x) {
                            return _c("rect", {
                              key: x,
                              attrs: {
                                x: "10",
                                y: 15 * x * 4,
                                rx: "5",
                                ry: "5",
                                width: "720",
                                height: "26"
                              }
                            })
                          })
                        )
                      ],
                      1
                    )
                  ]
                : _vm._l(_vm.thread, function(message) {
                    return _c(
                      "div",
                      { key: message.id, staticClass: "col-12" },
                      [
                        message.direction === 2
                          ? [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-9 bg-primary rounded" },
                                  [
                                    _c("p", { staticClass: "m-1 text-white" }, [
                                      _vm._v(_vm._s(message.body))
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-3" })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row mb-2" }, [
                                _c("div", { staticClass: "col" }, [
                                  _c("small", { staticClass: "m-1" }, [
                                    _vm._v(_vm._s(message.date))
                                  ])
                                ])
                              ])
                            ]
                          : [
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-3" }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-9 bg-light rounded" },
                                  [
                                    _c("p", { staticClass: "m-1" }, [
                                      _vm._v(_vm._s(message.body))
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row mb-2" }, [
                                _c("div", { staticClass: "col text-right" }, [
                                  _c("small", { staticClass: "m-1" }, [
                                    _vm._v(_vm._s(message.date))
                                  ])
                                ])
                              ])
                            ]
                      ],
                      2
                    )
                  })
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
        _c("div", { staticClass: "row notes-field bg-white" }, [
          _c("div", { staticClass: "col-10 pr-0" }, [
            _c(
              "div",
              {
                staticClass:
                  "border w-100 text-field text-field-sms d-flex align-items-center"
              },
              [
                _c("textarea", {
                  directives: [
                    { name: "auto-resize", rawName: "v-auto-resize" },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.sms,
                      expression: "sms"
                    }
                  ],
                  ref: "message",
                  staticClass: "px-3",
                  attrs: { placeholder: "Send SMS" },
                  domProps: { value: _vm.sms },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.sms = $event.target.value
                    }
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-2 pl-0 pointer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary position-relative",
                attrs: { disabled: !_vm.sms.length || _vm.loadingMessages },
                on: { click: _vm.sendSms }
              },
              [_c("span", { staticClass: "mod-icon-note" })]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mb-4" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [_c("error-field", { attrs: { errors: _vm.errors, field: "" } })],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              !_vm.variablesLoaded
                ? [
                    _c(
                      "div",
                      { staticClass: "col-12 px-0" },
                      [
                        _c(
                          "vue-content-loading",
                          { attrs: { width: 800, height: 40 } },
                          [
                            _c("rect", {
                              attrs: {
                                x: "10",
                                y: 10,
                                rx: "5",
                                ry: "5",
                                width: "720",
                                height: "26"
                              }
                            })
                          ]
                        )
                      ],
                      1
                    )
                  ]
                : [
                    _c(
                      "div",
                      _vm._l(_vm.modelVariables, function(
                        variable,
                        key,
                        index
                      ) {
                        return _c(
                          "span",
                          {
                            key: index,
                            staticClass:
                              "badge badge-primary mx-1 unselectable pointer",
                            on: {
                              dblclick: function($event) {
                                _vm.insertVariable(variable)
                              }
                            }
                          },
                          [_vm._v(_vm._s(key))]
                        )
                      })
                    )
                  ]
            ],
            2
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-27b2e44c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27b2e44c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/modals/Messages.vue
// module id = null
// module chunks = 